import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

import { useStore } from "@store/store";
import { materialCommonStyles } from "@utils/materialCommonStyles";
import { allowAlphaNumeric, allowOnlyNumbers } from "@utils/commonFunctions";
import { CreateJobStyle } from "../style";
import uncheckedIcon from "@assets/images/uncheck-icon.svg";
import checkedIconOrange from "@assets/images/cheked-icon-orange.svg";

function Detail(props) {
  const classes = CreateJobStyle();
  const materilClasses = materialCommonStyles();
  const [state] = useStore();

  return (
    <>
      <div className="form-row"> {/* Customer - Requester Name */}
        <div className="form-gourp two-column">
          <FormControl variant="outlined" className={classes.formControl}>
            <label className="label-text">Customer</label>
            <Select
              displayEmpty
              className={materilClasses.customSelect}
              MenuProps={{
                classes: {paper: materilClasses.customSelect},
              }}
              onChange={props.formik.handleChange("customerId")}
              value={props.formik.values.customerId}
              IconComponent={() => <ExpandMore/>}
            >
              <MenuItem value={""} disabled>
                Select Customer
              </MenuItem>
              {state?.customer?.loading ? (
                <MenuItem>Loading...</MenuItem>
              ) : (
                state.customer?.customers?.rows?.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  );
                })
              )}
            </Select>
            <FormHelperText className="error-text">
              {props.formik.touched.customerId &&
                props.formik.errors.customerId}
            </FormHelperText>
          </FormControl>
        </div>
        <div className="form-gourp">
          <FormControl variant="outlined">
            <label className="label-text">Requester Name</label>
            <TextField
              id="requesterName"
              placeholder="Requester name"
              variant="outlined"
              type="text"
              name="requesterName"
              onKeyPress={allowAlphaNumeric}
              onChange={props.formik.handleChange}
              value={props.formik.values.requesterName}
              error={
                props.formik.touched.requesterName &&
                Boolean(props.formik.errors.requesterName)
              }
              helperText={
                props.formik.touched.requesterName &&
                props.formik.errors.requesterName
              }
            />
          </FormControl>
        </div>
      </div>

      <div className="form-row"> {/* Assign Driver - Preload Charges */}
        <div className="form-gourp">
          <FormControl variant="outlined" className={classes.formControl}>
            <label className="label-text">Assign Driver</label>
            <Select
              displayEmpty
              className={materilClasses.customSelect}
              MenuProps={{
                classes: {paper: materilClasses.customSelect},
              }}
              onChange={props.formik.handleChange("driverId")}
              value={props.formik.values.driverId}
              IconComponent={() => <ExpandMore/>}
              disabled={props.isEdit}
            >
              <MenuItem value={""}>Select Driver</MenuItem>
              {state?.driver?.gettingDrivers ? (
                <MenuItem>Loading...</MenuItem>
              ) : (
                state?.driver?.getDriversData?.rows
                  ?.filter((item) => {
                    return item.active === 1;
                  })
                  .map((itm, indx) => {
                    return (
                      <MenuItem key={indx} value={itm.id}>
                        {itm.name}
                      </MenuItem>
                    );
                  })
              )}
            </Select>
          </FormControl>
        </div>
        <div className="form-gourp">
          <label className="label-text">Preload Charges</label>
          <FormControlLabel
            className="custom-checkbox"
            control={
              <Checkbox
                icon={<img src={uncheckedIcon} alt="CheckBox"/>}
                checkedIcon={<img src={checkedIconOrange} alt="CheckBox"/>}
                name="isPreloadChargeApplied"
                onChange={props.formik.handleChange("isPreloadChargeApplied")}
                checked={props.formik.values.isPreloadChargeApplied ?? false}
              />
            }
            label="Pre-load charges included"
          />
        </div>
      </div>

      {props.isEdit && (
        <div className="form-row">
          <div className="form-gourp">
            <FormControl variant="outlined" className={classes.formControl}>
              <label className="label-text" htmlFor="weight">
                Total weight (kg)
              </label>
              <TextField
                id="weight"
                placeholder="1000"
                variant="outlined"
                type="text"
                onKeyPress={allowOnlyNumbers}
                onChange={props.formik.handleChange("weight")}
                value={props.formik.values.weight}
                disabled
              />
            </FormControl>
          </div>
          <div className="form-gourp">
            <FormControl variant="outlined" className={classes.formControl}>
              <label className="label-text" htmlFor="quantity">
                Quantity
              </label>
              <TextField
                id="quantity"
                placeholder="Quantity"
                variant="outlined"
                type="text"
                onKeyPress={allowOnlyNumbers}
                onChange={props.formik.handleChange("quantity")}
                value={props.formik.values.quantity}
                disabled={
                  ![0, "Empty"].includes(props.formik.values.jobTypeLabel)
                }
                error={
                  props.formik.touched.quantity &&
                  Boolean(props.formik.errors.quantity)
                }
                helperText={
                  props.formik.touched.quantity && props.formik.errors.quantity
                }
              />
            </FormControl>
          </div>
        </div>)
      }
    </>
  );
}

export default Detail;
